<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
let time
export default {
  name: 'App',
  created () {
    this.leasionData()
    // let lang = window.localStorage.getItem('lang')
    // if (lang === '0') {
    //   this.$i18n.locale = 'en'
    // } else {
    //   this.$i18n.locale = 'zh'
    // }
  },
  destroyed () {
    clearInterval(time)
  },
  methods: {
    leasionData () {
      time = setInterval(p => {
        let data = JSON.parse(window.localStorage.getItem('gidList') || '[]')
        if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            this.$axiox.get('/api/ContentPublish/submitVerify?taskId=' + data[i].gid, 2, true).then(p => {
              if (!p.data) {
                data.splice(i, 1)
                window.localStorage.setItem('gidList', JSON.stringify(data))
              } else if (p.data === 'success') {
                this.$commonJs.alertTips({
                  type: 'success',
                  title: '成功',
                  content: data[i].name + '处理成功',
                  stayTime: 5
                })
                data.splice(i, 1)
                window.localStorage.setItem('gidList', JSON.stringify(data))
              } else if (p.data === 'inprocess') {
              } else {
                this.$commonJs.alertTips({
                  type: 'error',
                  title: '错误:',
                  content: data[i].name + p.data,
                  stayTime: 30,
                  needDel: true
                })
                data.splice(i, 1)
                window.localStorage.setItem('gidList', JSON.stringify(data))
              }
            })
          }
        }
      }, 5000)
    }
  }
}
// let ctrlPress = false
// document.onkeydown = e => {
//   if (e.keyCode === 17) {
//     ctrlPress = true
//   }
//   if (e.keyCode === 67) {
//     if (ctrlPress) {
//       // replaceDot()
//     }
//   }
// }
// document.onkeyup = e => {
//   if (e.keyCode === 17) {
//     ctrlPress = false
//   }
// }
document.oncopy = replaceDot
function replaceDot () {
  let bodyElement = document.body
  let selection = window.getSelection()
  if (window.clipboardData) { // Internet Explorer
    let copytext = selection
    if (!isNaN(parseFloat(copytext.toString().replace(/,/g, '')))) {
      window.clipboardData.setData('Text', copytext.toString().replace(/,/g, ''))
      return false
    }
  } else {
    let copytext = selection
    if (!isNaN(parseFloat(copytext.toString().replace(/,/g, '')))) {
      var newdiv = document.createElement('div')
      newdiv.style.position = 'absolute'
      newdiv.style.left = '-99999px'
      bodyElement.appendChild(newdiv)
      newdiv.innerHTML = copytext.toString().replace(/,/g, '')
      selection.selectAllChildren(newdiv)
      window.setTimeout(function () {
        bodyElement.removeChild(newdiv)
      }, 0)
    }
  }
}
</script>

<style>
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: left;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue